var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 15.4,
    viewBox: "0 0 19.5 15.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_browse",
    d: "M9.5,5.8l1.4,2.4.6,1h7.8v8H3.7V5.8H9.5m.7-2H2.6a.789.789,0,0,0-.8.8V18.4a.789.789,0,0,0,.8.8H20.5a.789.789,0,0,0,.8-.8V8.1a.789.789,0,0,0-.8-.8H12.7L11,4.3a.824.824,0,0,0-.8-.5Z",
    transform: "translate(-1.8 -3.8)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBrowse);
export default __webpack_public_path__ + "static/media/ic_browse.527239ce2a32d4e769d629c7ceda8f5b.svg";
export { ForwardRef as ReactComponent };